<script setup>
import {useReportOutput} from "@/components/report/outputs/useReportOutput";
import helpers from "@/lib/helpers";
import {getCurrentInstance} from "vue";
import ItemInventoryModal from "@/components/item/item-inventory-modal.vue";

const root = getCurrentInstance().proxy.$root

const props = defineProps({
  value: [String, Object]
})

const {v, extra} = useReportOutput(props)

const click = (event) => {
  console.log('v', props.value)
  if (event.shiftKey)
    root.$dialog.show(ItemInventoryModal, {id: props.value.raw, url: extra.value.parent_url})
  else
    helpers.global_lookup(v.value, true)
}

</script>

<template>
  <div v-if="$store.state.printing">{{ v }}</div>
  <b-link v-else @click="click">{{ v }}</b-link>
</template>

<style scoped>

</style>